/** @file Copy of a bone's parent world matrix (null for a root), taken at press time. */
import { POSE_LAYOUT } from '@pose2d/core/contracts/pose';
import type { Pose, SkeletonData } from '@pose2d/core/types';

/** A copy, so later poses do not move a drag's frame of reference. */
export function parentWorldOf(pose: Pose, data: SkeletonData, i: number): Float64Array | null {
  const p = data.bones[i]?.parent ?? -1;
  const W = POSE_LAYOUT.WORLD_STRIDE;
  return p < 0 ? null : pose.world.slice(p * W, p * W + W);
}
